import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  setIsEditingAnnotation,
  setSelectedRow,
} from "~/store/ducks/processAnnotations/actionTypes";
import { iconmap } from "./utils";

import { withNamespaces } from "react-i18next";
import "~/assets/css/icons.css";

const AnnotationColumn = (props) => {
  const { t, row, formatExtraData } = props;
  const { userSettings } = useSelector((state) => state.userSettingsReducer);

  const dispatch = useDispatch();
  const getUserTheme = () => {
    return userSettings.theme ? userSettings.theme : "default";
  };
  const foundIcon = iconmap(getUserTheme()).find((i) => i.id === row.iconid);

  const renderDeadline = () => {
    if (row && row.iconid !== "" && row.iconid !== undefined) {
      let deadline = "";
      if (row.deadline) {
        const arr = row.deadline.split("/");
        deadline = arr[2] + "/" + arr[1];
      }
      return <div className="tasks-deadline-date column-icon">{deadline}</div>;
    }
  };

  function renderTooltip(text, ...props) {
    return (
      <Tooltip id="button-tooltip" {...props}>
        {text}
      </Tooltip>
    );
  }
  return foundIcon ? (
    <div
      className="column-icon"
      onClick={() => {
        let clonedRow = JSON.parse(JSON.stringify(row));
        clonedRow.isPreview = true;
        formatExtraData.selectedRow &&
        formatExtraData.selectedRow.pnumber === row.pnumber
          ? dispatch(setIsEditingAnnotation(false))
          : dispatch(setSelectedRow(clonedRow));
      }}
    >
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip(t("taskPage.annotation.previewAnnotation"))}
      >
        {foundIcon.faIcon ? (
          <i className={`${foundIcon.faIcon} column-icon`} />
        ) : (
          <img
            src={foundIcon.image}
            style={{ width: "18px", height: "16px" }}
            alt="annotation-preview"
          />
        )}
      </OverlayTrigger>
      {renderDeadline()}
    </div>
  ) : null;
};
export default withNamespaces()(AnnotationColumn);
